import { render } from "./DialogCancelConfirm.vue?vue&type=template&id=53833388"
import script from "./DialogCancelConfirm.vue?vue&type=script&lang=js"
export * from "./DialogCancelConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script